import { IntersectionType, PartialType, PickType } from '@nestjs/swagger';
import { ContractorCreatableInterface } from '../interfaces/contractor-creatable.interface';
import { ContractorDto } from './contractor.dto';

export class ContractorCreateDto
  extends IntersectionType(
    PickType(ContractorDto, [
      'name',
      'corporation',
      'paymentType',
      'paymentRate',
    ]),
    PartialType(
      PickType(ContractorDto, [
        'description',
        'hangerAvailable',
        'finisherAvailable',
        'sprayerAvailable',
        'bumperAvailable',
        'bumperPaymentType',
        'bumperPaymentRate',
        'paintAvailable',
        'trimAvailable',
        'specialistAvailable',
        'active',
        'suspended',
        'archived',
        'canPerformHighCeilingTasks',
        'notes',
        'hangerCapacity',
        'finisherCapacity',
        'sprayerCapacity',
        'specialistCapacity',
        'paintCapacity',
        'trimCapacity',
        'bumperCapacity',
      ]),
    ),
  )
  implements ContractorCreatableInterface {}
